import styled from "styled-components";

export const Container = styled.div`
.ant-select-single.ant-select-lg:not(.ant-select-customize-input) .ant-select-selector {
    height: 44px;
}
` 